<template>
    <span>
        <v-row>
        <!-- TODO: @change mudou para @update:modelValue -->
        <!-- eslint-disable-next-line -->
        <v-checkbox v-model="dataOptions.options.legend.show"
            dense hide-details class="black--text" v-show="false"
            v-if="dataOptions && dataOptions.options && dataOptions.options.legend"
            @update:modelValue="refreshChart()" label="Legendas"></v-checkbox>
        <v-spacer/>
        <!-- TODO: @change mudou para @update:modelValue -->
        <!-- eslint-disable-next-line -->
        <v-checkbox v-model="dataOptions.options.dataLabels.enabled"
            dense hide-details v-show="false"
            v-if="dataOptions && dataOptions.options && dataOptions.options.dataLabels"
            @update:modelValue="refreshChart()" label="Indicadores"></v-checkbox>
        </v-row>
        <v-divider class="my-2"/>
        <apexchart-gdb :ref="code"
            :options="dataOptions.options"
            :series="dataOptions.series"></apexchart-gdb>
    </span>
</template>
<script>
// import ApexCharts from 'vue-apexcharts'
export default {
    name: 'ChartComponent',
    props:{
        dataOptions:{
            required:true,
            default:{}
        }
    },
    data:()=>({
        code:null,
        // dataOptions: {}
    }),
    mounted(){
        // this.initChart()
        this.code = this.generateRef()
    },
    methods:{
        generateRef() {
            const result = Math.random().toString(36).substring(2,7);
            return result;
        },
        refreshChart(){
            // this.$refs[this.code].updateOptions(this.dataOptions.options)
            this.$refs[this.code].refresh()
        },
    },
    computed:{
        // computedData(){
        //     let chartTypes = {
        //         line:{
        //             series: this.datavalues.map(obj=>obj),//[{ name: "Desktops", data: [10, 41, 35, 51, 49, 62, 69, 91, 148] }],
        //             options: {
        //                 chart: {
        //                     height: this.height,
        //                     type: 'line',
        //                     zoom: {
        //                         enabled: this.params.showZoomControls
        //                     }
        //                 },
        //                 dataLabels: {
        //                     enabled: this.params.showLegends
        //                 },
        //                 stroke: {
        //                     curve: 'straight'
        //                 },
        //                 title: {
        //                     text: this.params.title,
        //                     align: 'left'
        //                 },
        //                 grid: {
        //                     row: {
        //                         colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        //                         opacity: 0.5
        //                     },
        //                 },
        //                 xaxis: {
        //                     categories: this.datalabels.map(obj=>obj), //['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
        //                 },
        //                 tooltip: {
        //                     theme: false,
        //                 }
        //             },
        //         },
        //         bar:{
        //             series: this.datavalues.map(obj=>obj),//[{ name: "Desktops", data: [40, 43, 25, 41, 99, 42, 19, 11, 128] }],
        //             options: {
        //                 chart: {
        //                     height: this.height,
        //                     type: 'bar',
        //                     zoom: {
        //                         enabled: this.params.showZoomControls
        //                     }
        //                 },
        //                 dataLabels: {
        //                     enabled: this.params.showLegends
        //                 },
        //                 stroke: {
        //                     curve: 'straight'
        //                 },
        //                 title: {
        //                     text: this.params.title,
        //                     align: 'left'
        //                 },
        //                 grid: {
        //                     row: {
        //                         colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        //                         opacity: 0.5
        //                     },
        //                 },
        //                 xaxis: {
        //                     categories: this.datalabels.map(obj=>obj),//['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
        //                 }
        //             },
        //         },
        //         pie:{
        //             series: this.datavalues[0].data,
        //             options: {
        //                 chart: {
        //                     width: this.width,
        //                     type: 'pie',
        //                 },
        //                 labels: this.datalabels.map(obj=>obj)
        //             },
        //             legend: {
        //                 show: this.params.showLegends,
        //                 fontSize: '10px',
        //             }
        //         },
        //     }
        //     const chartOptions = chartTypes[this.params.type]
        //     console.log(chartOptions)
        //     return chartOptions
        // }
    },
    watch: {
        // propObject:{
        //     handler(value){
        //         const prop = value
        //         this.dataOptions = prop
        //     }, deep: true
        // }
    }
}
</script>